import { WalletProvider } from '@tronweb3/tronwallet-adapter-react-hooks';
import { useAtomValue } from 'jotai';
import { tronAdaptersAtom } from '@/atoms/tron';

export function TronProvider({ children }: { children: React.ReactNode }) {
  const adapters = useAtomValue(tronAdaptersAtom);
  return (
    <WalletProvider autoConnect adapters={adapters}>
      {children}
    </WalletProvider>
  );
}
